import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Box, Tooltip, Text } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';
import { getFieldValueByCalculator } from '../utils';

import type { MonthlyPaymentInputProps } from '../types';

const TotalClosingCostInput = (
  props: MonthlyPaymentInputProps
): JSX.Element => {
  const {
    value,
    label = 'Total closing costs',
    tooltip = "Overview of your total upfront closing costs required. Typically you should expect closing costs to be in the range of 2% to 5% of your home's price.",
  } = props;

  const currencyValue = _.isNil(value) ? '' : num.formatCurrency(value);

  const tooltipLabel = label;

  return (
    <Box display="flex" justifyContent="space-between">
      <Box>
        {/* @ts-ignore - ignore type error for label */}
        <Tooltip label={tooltipLabel} content={tooltip} />
      </Box>
      <Box>
        <Text size="small" bold>
          {currencyValue}
        </Text>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state, ownProps: MonthlyPaymentInputProps) => {
  const { calculator } = ownProps;
  return {
    value: getFieldValueByCalculator(state, calculator, 'totalClosingCost'),
  };
};

export default connect(mapStateToProps)(TotalClosingCostInput);
